import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Loader, Stack } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';
import { AddBlockStyles } from '@/modules/corporate/modules/feedback/views/FeedbackWall/components/CreateFeedbackModal/components/RelatedSkillsOrMindsets/style';
import { SkillItemRenderer } from '@/modules/corporate/modules/feedback/views/FeedbackWall/components/CreateFeedbackModal/components/RelatedSkillsOrMindsets/utils';
import ReviewCardListItem from '@/modules/skills/views/SkillReviewSubmission/components/SkillUserReview/components/ReviewCardListItem';
import { SkillType } from '@/types/schema';

import useSkillsFilter from '../../../../hooks/useSkillsFilter';
import { MENU_LIST_OVERRIDES } from './style';

function RelatedSkills({
  onChange,
  skillIds,
  isMindset,
  requestedFromUserIds,
}: {
  onChange: (value: string[]) => void;
  skillIds: string[];
  isMindset?: boolean;
  requestedFromUserIds: string[];
}) {
  const { t } = useTranslation(['Feedback', 'Skills']);
  const {
    fetching,
    selectedSkillsState,
    onRemoveSkill,
    SkillParam,
    searchText,
    setSearchText,
    filterGroups,
    open,
    addSkill,
    toggle,
  } = useSkillsFilter({ onChange, skillIds, isMindset });

  return (
    <Stack direction="col">
      {fetching ? (
        <Stack alignItems="center" className="mb-16 flex-1" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <>
          {selectedSkillsState?.length ? (
            <Stack className="mb-16" direction="col" gapY={20}>
              {selectedSkillsState?.map((skill) => {
                return (
                  <ReviewCardListItem
                    key={skill.id}
                    isMindset={isMindset}
                    removeSkill={onRemoveSkill}
                    showScoreFooter={false}
                    skill={skill as unknown as SkillType}
                  />
                );
              })}
            </Stack>
          ) : null}
        </>
      )}
      <Filter
        asyncOptions={{
          search: {
            placeholder: t(`Skills:${SkillParam}.SearchSkills`),
            value: searchText,
            onChange: setSearchText,
          },
        }}
        emptyLabel={isMindset ? t('Feedback:NoMindsetsDesc') : t('Feedback:NoSkillsDesc')}
        groups={filterGroups}
        itemRenderer={SkillItemRenderer}
        open={open}
        overrides={MENU_LIST_OVERRIDES}
        showActionButtons={false}
        value={(selectedSkillsState || []) as FilterOption[]}
        onChange={addSkill}
        onClose={toggle}
        onToggle={toggle}>
        <AddBlock
          className={AddBlockStyles}
          title={t(`Feedback:CreateFeedback.${SkillParam}.AddSkills`)}
        />
      </Filter>
    </Stack>
  );
}

export default RelatedSkills;
